import { Component, Input, OnInit } from "@angular/core";
import { GenericDrawerService } from "../../drawer/global-drawer.service";
import { EmailContentComponent } from "../email-content/email-content.component";
import { MomentModule } from "ngx-moment";
import {
  PinnedItem,
  PinnedModels,
} from "../../main/accountant/pinned-panel/pinned-models";
import { PinComponent } from "src/app/design-system/components/pin/pin.component";
import { EmailService } from "../email.service";
import { EmailMessage } from "../email.types";
import { DashboardService } from "../../dashboard.service";
import { TooltipModule } from "ngx-bootstrap/tooltip";

@Component({
    selector: "email-card",
    templateUrl: "./email-card.component.html",
    styleUrls: [
        "./email-card.component.css",
        "../../main/accountant/pinned-panel/pinned-card/pinned-card.component.scss",
    ],
    imports: [MomentModule, PinComponent, TooltipModule]
})
export class EmailCardComponent implements OnInit {
  @Input() email: any;
  @Input() isPinned: boolean = false;
  @Input() pin: PinnedItem;
  pinTypeThread = PinnedModels.Thread;
  constructor(
    private genericDrawerService: GenericDrawerService,
    private emailService: EmailService,
    private dashboardService: DashboardService,
  ) {}

  ngOnInit(): void {}

  selectThread() {
    this.dashboardService.show_loading.next(true);

    this.emailService
      .getEmailThread(this.email.uuid)
      .subscribe((data: EmailMessage[]) => {
        this.dashboardService.show_loading.next(false);
        this.email.messages = data;

        this.genericDrawerService.changeComponent(EmailContentComponent, {
          thread: this.email,
        });
      });
  }
}
